import React from 'react';

import { FieldError, UseControllerOptions } from 'react-hook-form';

import { AutocompleteRenderInputParams } from '@material-ui/lab';

import { FormAutocomplete } from './form-autocomplete';

import { STATES } from '../../util/states';

type InputProps = UseControllerOptions & {
  label: string;
  required?: boolean;
  error?: FieldError;
  className?: string;
  renderInput?: (params: AutocompleteRenderInputParams) => React.ReactNode;
  defaultValue?: string;
  disabled?: boolean;
};

export const FormStateAutocomplete = (props: InputProps) => (
  <FormAutocomplete
    {...props}
    options={[''].concat(Object.keys(STATES))}
    getOptionLabel={(option) => (option ? STATES[option as keyof typeof STATES] : '')}
  />
);
